import { render, staticRenderFns } from "./add-remote-proofing.vue?vue&type=template&id=790fabe9&scoped=true&"
import script from "./add-remote-proofing.vue?vue&type=script&lang=js&"
export * from "./add-remote-proofing.vue?vue&type=script&lang=js&"
import style0 from "./add-remote-proofing.vue?vue&type=style&index=0&id=790fabe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fabe9",
  null
  
)

export default component.exports